export const RoleOptions = [
  { value: 'Admin', text: 'Administrator', adminOnly: true },
  { value: 'TS', text: 'Territory Servant (TS)' },
  { value: 'CO', text: 'Circuit Overseer (CO)' },
  { value: 'SO', text: 'Service Overseer (SO)' },
  { value: 'GO', text: 'Group Overseer (GO)' },
  { value: 'RP', text: 'Regular Pioneer (RP)' },
  { value: 'RP-E', text: 'Regular Pioneer Enhanced (RP-E)' },
  { value: 'PUB', text: 'Publisher (PUB)' },
];
